cb.define([], function () {
  var RM_rm_dayEndReceipt_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) { 
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
	    var report_id = 0;
	    var report_name = '';
      viewmodel.on("afterSave",function(err,result){
        // 保存后，调用上传接口
        var param = {
          billnum:"rm_dayEndReceipt",
          data: JSON.stringify([{"id":"22121"}])
        };
        var proxy = cb.rest.DynamicProxy.create(
          { ensure:
            { url: "/bill/batchaudit",
              method: "POST"
            }
          });
        proxy.ensure(param, function(err, result) {
          console.log("ssss");
        });
      });
	    viewmodel.on('stockQuery', function () {
		  debugger;
		  
		  report_id = viewmodel.get('stockReportId').getValue();
		  if(report_id > 0){
		    viewmodel.communication({ type: 'menu', payload: {menuCode:'SJ0201', carryData: { query: {key:'reportId',value:report_id}, title: viewmodel.get('stockReportName').getValue()}}});
		    return;
	    }
		
      var proxy = cb.rest.DynamicProxy.create({
          settle: { url: 'report/publish', method: 'POST' }
        });
      var groupSchemaId = cb.rest.AppContext.option.dailyInventoryDailyPlan;
		  var simpleVOs = [];
		  var defwhere = {}; 
       defwhere['field'] = 'store';
       defwhere['value1'] = cb.rest.AppContext.user.storeId;
       defwhere['op'] = 'eq';
       simpleVOs.push(defwhere);
		  var filterVO = {"simpleVOs":simpleVOs,"isExtend":true};
      var params = {
			billnum : "stock_stockanalysis",
			reportName:"日结单库存日报_" + viewmodel.get('createTime').getValue(),
			condition : filterVO
      };
      if(groupSchemaId > 0)
      {
			   params.groupSchemaId = groupSchemaId;
		  }
      else
      {
			   params.groupSchemaName = "日结库存";
		  }
      proxy.settle(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error'); 
            return;
          }
		  if (result != undefined) {
			  viewmodel.get('stockReportId').setValue(result.id);
			  viewmodel.get('stockReportName').setValue(result.name);
			  
			  viewmodel.communication({ type: 'menu', payload: {menuCode:'SJ0201', carryData: { query: {key:'reportId',value:result.id}, title: result.name}}});
		  }
        });
    });
      viewmodel.on('saleQuery', function () {
		    // debugger;			
		  report_id = viewmodel.get('saleReportId').getValue();
		  if(report_id > 0){
		     viewmodel.communication({ type: 'menu', payload: {menuCode:'SJ0106', carryData: { query: {key:'reportId',value:report_id}, title: viewmodel.get('saleReportName').getValue()}}});
		     return;
	    }	
       var proxy = cb.rest.DynamicProxy.create({
          settle: { url: 'report/publish', method: 'POST' }
       });
       var simpleVOs = [];
       var defwhere = {};
       defwhere['field'] = 'fbitSettle';
       defwhere['value1'] = 0;
       defwhere['op'] = 'eq';
       simpleVOs.push(defwhere);
/*	     defwhere = {};
       defwhere['field'] = 'iPresellState';
       defwhere['value1'] = 5;
       defwhere['op'] = 'neq';	   
       simpleVOs.push(defwhere);
	   */
	   var storeid = cb.rest.AppContext.user.storeId;
	   defwhere = {};
       defwhere['field'] = 'store';
       defwhere['value1'] = storeid;
       defwhere['op'] = 'eq';	   
       simpleVOs.push(defwhere);	   
	   var filterVO = {"simpleVOs":simpleVOs,"isExtend":true};
       var params = {
			 billnum : "rm_salereceipts_report",
			 reportName:"日结单销售日报_" + viewmodel.get('createTime').getValue(),
			 condition : filterVO,
			 groupSchemaName : "待日结数据"
       };
        proxy.settle(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
		  if (result != undefined) {
			  viewmodel.get('saleReportId').setValue(result.id);
			  viewmodel.get('saleReportName').setValue(result.name);
			 
			  viewmodel.communication({ type: 'menu', payload: {menuCode:'SJ0106', carryData: { query: {key:'reportId',value:result.id}, title: result.name}}});
		  }
        });
     });
   },
  }
  try {
    module.exports = RM_rm_dayEndReceipt_VM_Extend;
  } catch (error) {

  }
  return RM_rm_dayEndReceipt_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_dayEndReceipt_VM.Extend.js